export const Pagination = {
  LIST_LENGTH: 25,
};
